import { render, staticRenderFns } from "./CortexGreenIcon.vue?vue&type=template&id=92a6f33e&"
import script from "./CortexGreenIcon.vue?vue&type=script&lang=ts&"
export * from "./CortexGreenIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports